import { defineSemanticTokens } from "@chakra-ui/react/styled-system";
import { themeTokens } from "@commercetools/nimbus-tokens";

export const shadows = defineSemanticTokens.shadows(themeTokens.shadow);
